import { cva } from 'class-variance-authority'
import React from 'react'
import { IconType } from 'react-icons'

import { SearchResultIconColor } from '@/components/misc/GlobalSearch/types'

const tileVariants = cva('size-10 grid place-items-center border rounded-xl', {
  variants: {
    color: {
      blue: 'bg-blue-50 border-blue-100',
      green: 'bg-green-50 border-green-100',
      purple: 'bg-purple-50 border-purple-100',
    },
  },
})

const iconVariants = cva('', {
  variants: {
    color: {
      blue: 'text-blue-500',
      green: 'text-green-600',
      purple: 'text-purple-600',
    },
  },
})

interface Props {
  icon: IconType
  color: SearchResultIconColor
}

/**
 * The coloured icon tile shown at the start of a global search result, so each
 * result group looks consistent and only differs by icon and colour.
 */
const SearchResultIcon: React.FC<Props> = ({ icon: Icon, color }) => (
  <div className={tileVariants({ color })}>
    <Icon className={iconVariants({ color })} />
  </div>
)

export default SearchResultIcon
